/* ------------------------------------------------------------------------------
 *
 *  # Buttons extension for Datatables. Excel examples
 *
 *  Demo JS code for datatable_extension_buttons_excel.html page
 *
 * ---------------------------------------------------------------------------- */


// Setup module
// ------------------------------


const DatatableButtonsExcel = function () {

    const _componentDatatableButtonsExcel = function () {
        if (!$().DataTable) {
            console.warn('Warning - datatables.min.js is not loaded.');
            return;
        }

        // Setting datatable defaults
        $.extend($.fn.dataTable.defaults, {
            autoWidth: false,
            dom: '<"datatable-header justify-content-start"f<"ms-sm-auto"l><"ms-sm-3"B>><"datatable-scroll-wrap"t><"datatable-footer"ip>',
            language: {
                searchPlaceholder: 'Type to filter...',
                lengthMenu: '<span class="me-3">Show:</span> _MENU_',
                search: '<span class="me-3">Filter:</span> <div class="form-control-feedback form-control-feedback-end flex-fill">_INPUT_<div class="form-control-feedback-icon"><i class="ph-magnifying-glass opacity-50"></i></div></div>',
                paginate: { 'first': 'First', 'last': 'Last', 'next': document.dir == "rtl" ? '&larr;' : '&rarr;', 'previous': document.dir == "rtl" ? '&rarr;' : '&larr;' }
            }
        });

    };


    //
    // Return objects assigned to module
    //

    return {
        init: function () {
            _componentDatatableButtonsExcel();
        }
    }
}();


// Initialize module
// ------------------------------

document.addEventListener('DOMContentLoaded', function () {
    DatatableButtonsExcel.init();
});
